import { createSelector } from '@ngrx/store';
import { selectConsumersState } from '../../reducers';
import { ConsumersState } from 'src/app/core/store/consumers/consumers.reducer';

/**
 * Get End Users
 */
export const endUsers = createSelector(
  selectConsumersState,
  (state: ConsumersState) => state.endUsers
);
